import { inject, Injectable } from '@angular/core';
import { OtpRepository } from '../../../@core/repositories/otp.repository';
import { Observable } from 'rxjs';
import { environment } from '@environments/environment';
import { RequestOtpV3Dto, RequestOtpV3Resp } from '@usecase/otp/request-otp-v3/request-otp-v3.type';
import { RequestOtpDto, RequestOtpResp } from '@usecase/otp/request-otp/request-otp.type';
import { HttpService } from '@shared/service.http';

@Injectable({
    providedIn: 'root'
})

export class OtpAdapter extends OtpRepository {
    private httpService = inject(HttpService);

    requestOtp(payload: RequestOtpDto): Observable<RequestOtpResp> {
        return this.httpService.post(`${environment.serviceApi}request/otp`, payload);
    }
    requestOtpV3(payload: RequestOtpV3Dto): Observable<RequestOtpV3Resp> {
        return this.httpService.post(`${environment.serviceApi}v3/request/otp`, payload);
    }
}
